// extracted by mini-css-extract-plugin
export default {"detailsContainer":"DetailsPage_detailsContainer__s+kNK","movieImage":"DetailsPage_movieImage__rxepa","bgImg":"DetailsPage_bgImg__5YES+","strongP":"DetailsPage_strongP__or5i3"};